export default "__VITE_ASSET__acbf8588__"